(ns renolit-roofing-service.shared.localization.dictionaries.es
  (:require [renolit-roofing-service.shared.localization.dictionaries.es.notifications-templates :as es.ntf-tpl]))

(def ^:const registry
  {:notifications-templates es.ntf-tpl/registry
   :notification {:today "Hoy"
                  :yesterday "Ayer"
                  :just-now "Justo ahora"
                  :minute-ago "Hace 1 minuto"
                  :minutes-ago "Hace %1 minutos"
                  :hour-ago "Hace 1 hora"
                  :hours-ago "Hace %1 horas"
                  :day-ago "1 día"
                  :days-ago "%1 días"
                  :empty "No tienes notificaciones"}
   :common {:go-back "Volver atrás"
            :project "Proyecto"
            :service "Servicio"
            :service-information "Información del servicio"
            :finalize-and-send "Finalizar y enviar a LAB"
            :information "Información"
            :zone "Zona"
            :zones "Zonas"
            :zones-indicated "Zonas indicadas"
            :visit-program "Programa de visita"
            :no-data "Sin datos"
            :close "Cerrar"
            :cancel "Cancelar"
            :clear "Limpiar filtros"
            :select "Selecciona"
            :home "Inicio"
            :projects "Proyectos"
            :profile "Perfil"
            :close-session "Cerrar sesión"
            :loading "Cargando..."
            :okay "Bueno"
            :accept-continue "Aceptar y continuar"
            :final-report "Informe final"
            :apply "Aplicar"}
   :date-time-formats {:local-date "dd/MM/yyyy"
                       :date-and-time "yyyy-MM-dd HH:mm"}
   :label {:first-name "Nombre"
           :last-name "Apellidos"
           :company "Nombre de la empresa"
           :nif "NIF"
           :user-role "Tipología de usuario"
           :email "Correo electrónico"
           :password "Contraseña"
           :confirm-password "Confirmar contraseña"
           :verification-code "Código de verificación"
           :new-password "Nueva contraseña"}
   :placeholder {:first-name "Escribe tu nombre"
                 :last-name "Escribe tus apellidos"
                 :company "Escribe nombre"
                 :nif "Ej. B12345678"
                 :user-role "REA/Laboratorio/Instalador"
                 :email "nombre@nombre.com"
                 :password "Escribe tu contraseña"
                 :confirm-password "Confirma tu contraseña"
                 :search "Buscar"
                 :zone-name "Nombre de zona"}
   :button {:register "Registrar"
            :login "Iniciar sesión"
            :verify "Verificar"
            :resend-code "Reenvíar código"
            :recover-password "Recuperar contraseña"
            :change-password "Cambiar contraseña"}
   :enum {:user-role {:rae "RAE"
                      :laboratory "Laboratorio"
                      :installer "Instalador"}}
   :error-msg {:password-format-incorrect "La contraseña debe contener mínimo 8 caracteres y una minúscula."
               :password-mismatch "Las contraseñas no coinciden"
               :username-already-in-use "Ese correo electrónico ya está en uso. Prueba con otro."
               :incorrect-username-or-password "El usuario o la contraseña no son correctos."
               :unable-to-create-db-user "No se puede crear el usuario en la base de datos"
               :invalid-code "Código de verificación proporcionado no válido, inténtelo de nuevo."
               :could-not-create-csv-file "No se pudo crear el archivo CSV. Inténtelo de nuevo."
               :unknown "Ha ocurrido un error desconocido. Inténtelo de nuevo más tarde."}
   :page {:installer {:home {:title "Inicio"
                             :tabs {:in-progress "Análisis en progreso"
                                    :completed "Análisis completado"}
                             :no-services "No hay servicios"
                             :start-diagnostics "Iniciar diagnóstico"
                             :edit-diagnostics "Editar diagnóstico"}
                      :service-detail {:title "Detalles del servicio"
                                       :service-information "Información del servicio"
                                       :project-information "Información del proyecto"
                                       :no-work-packages "No hay paquetes de trabajo"
                                       :tasks-progress "%1 de %2 completadas"
                                       :confirm-submit-title "Confirmar envío"
                                       :confirm-submit-message "¿Estás seguro de que quieres finalizar y enviar este servicio al laboratorio?"
                                       :confirm-submit-warning "Esta acción no se puede deshacer."
                                       :filter-modal {:title "Filtros"
                                                      :visit-program "Programa de visita"
                                                      :zone "Zona"
                                                      :apply "Aplicar"}}
                      :service-information {:title "Información del servicio"}
                      :review-wp-detail {:title "Inspección visual"
                                         :filters "Filtros"
                                         :view-specific-point "Ver punto específico"
                                         :view-zone "Ver zona"
                                         :add-observation "Añadir observación o incidencia"
                                         :finalize-and-send "Finalizar y enviar a LAB"
                                         :no-reviews "No hay revisiones para esta categoría"}
                      :add-observation-popup {:title "Añadir"
                                              :observation "Observación"
                                              :incidence-grade "Grado de incidencia"
                                              :locate-on-map "Ubicar en el mapa"
                                              :add-images "Añadir imágenes"
                                              :description "Descripción"
                                              :dirt-type "Tipo de suciedad"
                                              :photo-position "Posición de la foto"
                                              :face "Cara"
                                              :sample-description "Descripción de la muestra"
                                              :save "Guardar"
                                              :cancel "Cancelar"
                                              :upload-error "Error al subir las imágenes. Inténtelo de nuevo."
                                              :invalid-file-type "Solo se permiten imágenes JPEG, PNG o WebP."}
                      :add-review-popup {:title "Añadir"
                                         :zone "Zonas"
                                         :wp "WP"
                                         :wp-type "Tipo de WP"
                                         :task "Tarea"
                                         :comment "Comentario"
                                         :save "Guardar"
                                         :cancel "Cancelar"}
                      :service-info {:save "Guardar"}}
          :laboratory {:home {:title "Servicios registrados"
                              :tabs {:in-review "En revisión"
                                     :history "Historial"}
                              :register-membrane "Registrar membrana"
                              :search-placeholder "Buscar servicio..."
                              :no-services "No hay servicios registrados"
                              :table-header {:service-number "Nº del servicio"
                                             :reason "Motivo"
                                             :diagnosis-date "Fecha de diagnóstico"
                                             :project-number "Nº proyecto"
                                             :project-name "Nombre proyecto"
                                             :technician "Técnico"
                                             :status "Estado"
                                             :sample-analysis "Análisis"}}
                       :sample-analysis {:title "Datos diagnóstico"
                                         :sample "Muestra"
                                         :photo-valid "¿Foto válida?"
                                         :yes "Sí"
                                         :no "No"
                                         :crack-level "Crack Level"
                                         :observations "Observaciones del técnico"
                                         :request-repetition "Solicitar repetir muestra"
                                         :sample-info "Información de la muestra"
                                         :field-report "Reporte de campo"
                                         :next "Siguiente"
                                         :previous "Anterior"
                                         :finalize-report "Finalizar informe"
                                         :success-title "¡Informe finalizado con éxito!"
                                         :success-body "Podrás editar el informe desde el panel de proyectos."
                                         :success-ok "OK! Entendido"
                                         :project-info "Información del proyecto"
                                         :service-info "Información del servicio"
                                         :back-to-list "Volver a la lista de servicios"
                                         :sample-info-headers {:field-report "Rep. campo"
                                                               :zone "Zona"
                                                               :dirt-type "Suciedad tipo"
                                                               :photo-position "Pos. foto"
                                                               :face "Cara"}}
                       :report {:back-to-list "Volver a la lista de proyectos"
                                :back-to-edit "Volver a editar informe"
                                :save "Guardar"
                                :create-report "Crear informe resumen"
                                :send-to-rae "Enviar a la RAE"
                                :visual-inspection "Inspección visual"
                                :non-destructive "Ensayo no destructivo"
                                :destructive "Ensayo destructivo"
                                :conclusion "Conclusión"
                                :conclusion-per-visit "Conclusión por programa de visita"
                                :membrane-years "Años de vida de la membrana"
                                :final-conclusion "Conclusión final"
                                :focused-review "Revisión focalizada"
                                :general-review "Revisión general por zona"
                                :comments "Comentarios"
                                :service-data "Datos del servicio"
                                :lifecycle "Ciclo de vida del techo (estimación)"
                                :important-comments "Listado de comentarios importantes y acción sugerida"
                                :go-to-project "Ir a información del proyecto"
                                :go-to-service "Ir a información del servicio"
                                :sort-chronologically "Ordenar por: cronológicamente"
                                :comment-type "Tipo"
                                :comment-action "Comentario o acción"
                                :comment-placeholder "Escribe un comentario..."
                                :type-observation "Observación"
                                :type-incidence "Incidencia"}}
          :register {:title "Crea tu cuenta"
                     :subtitle "Introduce los siguientes datos para crear tu cuenta"
                     :login-link "Inicia sesión aquí"
                     :login-text "¿Ya tienes una cuenta?"}
          :login {:title "Accede a tu cuenta"
                  :subtitle "Introduce tu email y contraseña para acceder"
                  :forgot-password-link "He olvidado mi contraseña"
                  :register-text "¿Aún no tienes cuenta?"
                  :register-link "Regístrate aquí"}
          :code-verify {:title "Verifica tu cuenta"
                        :subtitle "Introduce el código que has recibido por email para poder verificar tu cuenta"
                        :spam-warning "Por favor revisa también la carpeta de spam de tu correo, puede que el email esté allí"
                        :successful-resend "El código se ha reenviado correctamente."}
          :forgot-password {:title "¿Has olvidado tu contraseña?"
                            :subtitle "Introduce tu correo electrónico y recibirás un código para verificar la nueva contraseña"}
          :profile {:title "Mi perfil"
                    :subtitle "Introduce la siguiente información para completar tu perfil"
                    :save "Ahorrar"}
          :home {:user-greetings "¡Hola %1!"
                 :registered-projects "Proyectos registrados"
                 :need-review "necesitan revisión"
                 :projects-need-review "Proyectos necesitan revisión"
                 :age-of-projects "Antigüedad de los proyectos"
                 :view-list "Ver lista"
                 :latest-projects-registered "Últimos proyectos registrados"
                 :see-full-list "Ver lista completa"
                 :analyzed "Analizadas"
                 :pending-analysis "Pendientes analizar"
                 :less-than-10-years "Menos de 10 años"
                 :more-than-10-years "Más de 10 años"}
          :project {:list {:title "Proyectos registrados"
                           :all "Todas"
                           :alerts "Alertas"
                           :antique "Antigüedad"
                           :revision "Revisión"
                           :state "Estado"
                           :status "Estado"
                           :filters "Filtros" ;:name :account-name :product :warranty-number :building-state :installation-date
                           :filters-title "Filtros de proyecto"
                           :requires-review "Requiere revisión"
                           :aged-gt-10-years "Más de 10 años"
                           :table-header {:id     "Identificador"
                                          :number  "Nº de proyecto"
                                          :name     "Nombre de proyecto"
                                          :account-name     "Nombre de la cuenta"
                                          :product          "Producto"
                                          :warranty-number      "Nº garantía"
                                          :building-state   "Provincia"
                                          :installation-date "Fecha instalación"}}
                    :details {:start-diagnostic-service "Empezar servicio diagnóstico"
                              :basic-project-data "Datos básicos del proyecto"
                              :building-address "Dirección del edificio"
                              :warranty "Garantía"
                              :meteorological-indicators "Indicadores metereológicos"
                              :roof-life-cycle-estimate "Ciclo de vida del techo (estimación)"
                              :diagnosis-made "Diagnósticos realizados"
                              :view-alerts "Ver alertas"
                              :expected-product-life "Vida útil esperada del producto"
                              :actual-product-life "Vida útil actual del producto"
                              :critical-window "Ventana crítica"
                              :end-of-guarantee "Días hasta el fin de la garantía"
                              :end-of-critical-window "Días hasta la ventana crítica"
                              :theoretic-degradation-curve "Curva de degradación teórica"}}
          :service {:add {:title "Servicio diagnóstico"
                          :activate-diagnostic-service "Activar servicio diagnóstico"
                          :service-data "Datos del servicio"
                          :customer-data "Datos del cliente"
                          :building-information "Información del edificio"
                          :roof-structure "Estructura del tejado"
                          :success-msg "El servicio se ha creado correctamente"
                          :failure-msg "Se produjo un error al crear el servicio"
                          :delete-confirmation-title "¿eliminar confirmación?"}
                    :placeholder {:name "Co-Working Building Roof – RENOLIT Worms"
                                  :origin "New Lead / Warranty Alarm / Window Alarm / Scheduled"
                                  :reason-example "Solar"
                                  :reason-text "RENOLIT Worms wants to install flexible PV panels, in an old roof, and would like to determine the health status of the roof and the remaining life expectancy of its performance. They would like to know if there is a need for a roof renovation before the solar installation."
                                  :objective "Life Cycle / Health assessment to determine alignment with Solar Installation"
                                  :manager "ALKORPLAN F 1,5"
                                  :contractor "RENOLIT iberica"
                                  :inspector "Miguel Cabezas"
                                  :last-diagnosis-date "10/2/2024"
                                  :last-maintenance-date "10/2/2025"
                                  :client-name "Airpharm"
                                  :client-profile "Building Owner / Installer / Prescriber (Architect) / Real State (Buyer, Due Diligence)"
                                  :company-owner "Airpharm"
                                  :company-industry "Industrial"}}
          :general-revision-dropdpwn {:all-zones "Todas las zonas"}
          :zone {:general-revision "Revisión general de zona"
                 :focused-revision "Revisión focalizada"
                 :zones "Zonas"
                 :wp "WP"
                 :wp-type "WP"
                 :task "Tarea"
                 :comment "Comentario"
                 :name "Nombre del zona"}
          :client {:placeholder {:name "Nombre del cliente"
                                 :profile "Perfil del cliente"
                                 :company-owner "Propietario de la empresa/edificio"
                                 :company-industry "Actividad de la empresa/edificio"}}
          :building {:placeholder {:height "3,5"
                                   :inclination "10/1"
                                   :upstand "0"
                                   :surface "400"}}
          :roof {:placeholder {:membrane "ALKORPLAN BRIGHT"
                               :application-method "F"
                               :support "Soporte"
                               :protective-glue "None"
                               :vapor-barrier "81012/005"
                               :glue-type "RENOLIT DUALFIX"
                               :thermal-insulation "Rockwool"
                               :separation-layer "None"
                               :color "Charcoal"
                               :fixation "Mechanically fixed / Ballasted (gravel / paving slabs) / Bonded (PUR / bituminous glue)"}}}
   :domain {:project {:name "Nombre del proyecto"
                      :number "Número de proyecto"
                      :address "Dirección"
                      :project-name "Nombre del proyecto"
                      :account-name "Nombre de la cuenta"
                      :building-type "Tipo de edificio"
                      :building-type-text "Tipo de edificio (texto)"
                      :product "Producto"
                      :product-text "Producto (texto)"

                      :end-customer-name "Nombre de cliente final"
                      :project-number "Número de proyecto"
                      :service-manager "Responsable del proyecto"
                      :total-roof-area "Superficie total del techo (m2)"
                      :closing-date "Fecha de cierre o inicio de ejecución"
                      :type "Type"
                      :building-country "País"
                      :building-region "Región"
                      :building-state "Estado o provincia"
                      :building-city "Ciudad"
                      :building-zip "Código postal"
                      :building-street "Calle"

                      :warranty-number "Nº de garantía"
                      :insured-period-years "Período asegurado (años)"
                      :material-type "Tipo de material"
                      :thickness "Espesor"
                      :valid-until "Válido hasta"

                      :avg-anual-temperature "Temperatura media anual"
                      :max-temperature "Temperatura máxima"
                      :min-temperature "Temperatura mínima"
                      :accumulated-precipitation "Precipitación acumulada"
                      :hail-days "Días con granizo"
                      :avg-sunlight-hours "Promedio de horas de sol"
                      :solar-irradiation "Irradiación solar (GHI)"
                      :avg-wind-speed "Velocidad media del viento"}
            :service {:name "Nombre del servicio"
                      :reason "Motivo"
                      :created-at "Fecha de creación"
                      :last-diagnosis-date "Fecha del último diagnóstico"
                      :state "Estado"
                      :inspector "Técnico"
                      :report "Informe"
                      :origin "Origen"
                      :reason-text "Motivo (texto)"
                      :objective "Objetivo"
                      :manager "Responsable del servicio"
                      :contractor "Contratista autorizado para diagnóstico"
                      :last-maintenance-date "Fecha del último mantenimiento"
                      :responsible "Responsable del servicio"
                      :observation {:observation "Observación"
                                    :incidence-level "Grado de incidencia"
                                    :description "Descripción"}}
            :client {:name "Nombre del cliente"
                     :profile "Perfil del cliente"
                     :company-owner "Propietario de la empresa/edificio"
                     :company-industry "Actividad de la empresa/edificio"}
            :building {:height "Altura del edificio"
                       :inclination "Inclinación del tejado"
                       :upstand "Upstand"
                       :surface "Superficie de servicio"}
            :roof {:membrane "Membrana de cubierta"
                   :application-method "Método de aplicación"
                   :support "Soporte"
                   :protective-glue "Capa protectora / Adhesivo"
                   :vapor-barrier "Barrera de vapor"
                   :glue-type "Tipo de adhesivo"
                   :thermal-insulation "Aislamiento térmico"
                   :separation-layer "Capa de separación / Imprimación"
                   :color "Color"
                   :fixation "Fixation"}
            :zone {:name "Nombre del zona"
                   :wp "WP"
                   :wp-type "WP type"
                   :task "Task"
                   :comment "Commentario"}
            :choices {:service-reason {:photovoltaic-solar-system-installation "Installation of photovoltaic solar system"
                                       :roof-refurbishment-renovation "Roof refurbishment / renovation"
                                       :energy-efficiency-upgrade "Energy efficiency upgrade"
                                       :building-purchase-sale-asset-valuation "Building purchase / sale (due diligence) / Asset valuation"
                                       :technical-risk-assessment "Technical risk assessment"
                                       :water-ingress-leaks "Water ingress / leaks"
                                       :impact-of-objects-on-roof "Impact of objects on the roof"
                                       :damage-by-third-party-works "Damage caused by third-party works"
                                       :damage-during-maintenance-works "Damage during maintenance works"
                                       :fire "Fire"
                                       :severe-weather-event "Severe weather event (storm, wind, hail, snow/ice)"
                                       :rooftop-structures-technical-equipment-installation "Installation of rooftop structures or technical equipment"
                                       :insurance-company-request "Insurance company request"
                                       :design-team-consultant-surveyor-requirement "Requirement from design team / consultant / Surveyor"
                                       :periodic-inspection "Periodic inspection"
                                       :other "Other (to be specified)"}
                      :service-origin {:new-lead "New Lead"
                                       :warranty-alarm "Warranty Alarm"
                                       :window-alarm "Window Alarm"
                                       :scheduled "Scheduled"}
                      :service-status {:review-pending "Pendiente revisión"
                                       :field-visit "Visita de campo"
                                       :laboratory "Laboratorio"
                                       :finalization-phase "Fase de finalización"
                                       :diagnosis-closed "Diagnóstico cerrado"}
                      :customer-profile {:building-owner "Building Owner"
                                         :installer "Installer"
                                         :prescriber "Prescriber / Architect"
                                         :real-estate "Real State (Buyer, Due Diligence)"}
                      :fixation {:mechanically-fixed "Mechanically fixed"
                                 :ballasted "Ballasted (gravel / paving slabs)"
                                 :bonded "Bonded (PUR / bituminous glue)"}
                      :revision-type {:general-revision "Revisión general de zona"
                                      :focused-revision "Revisión focalizada"}
                      :wp {:visual-inspection "Inspección visual"
                           :non-destructive-testing "Ensayo no destructivo"
                           :destructive-testing "Ensayo destructivo"}
                      :wp-type {:from-below "Desde abajo"
                                :installation "Instalación"
                                :condition-of-the-cover "Estado de la cubierta"
                                :nil "Todos"}
                      :dirt-types {:sand "Arena"
                                   :chemistry "Química"
                                   :biological-bio "Biológica"
                                   :water "Agua"
                                   :shadow "Sombra"
                                   :others "Otros"}
                      :photo-position {:vertical "Vertical"
                                       :horizontal "Horizontal"}
                      :face {:n "N" :s "S" :e "E" :w "W"}
                      :incidence-level {:action-required "Acción requerida"
                                        :monitoring "Seguimiento"
                                        :information "Información"}
                      :observation {:fitted-field-sheets "Láminas de campo ajustadas"
                                    :main-field-area "Zona principal del campo"
                                    :metallic-unions "Uniones metálicas"
                                    :fastening-centers "Centros de fijación"
                                    :supports "Soportes"
                                    :weld-width "Ancho de soldadura"
                                    :exits "Salidas"
                                    :channels "Canales"
                                    :seam-sealer "Sellador de costuras"
                                    :straps-for-the-glutes "Correas para los remates"
                                    :deck-straps "Correas de cubierta"
                                    :corner-patches "Parches de esquina"
                                    :penetrations "Penetraciones"
                                    :finished "Acabados"
                                    :plant "Maquinaria"
                                    :sacrificial-layer "Capa sacrificial"
                                    :baseboards "Rodapiés"
                                    :alkordesign "Alkordesign"
                                    :alkorsolar "Alkorsolar"
                                    :debris "Escombros"
                                    :damage "Daños"
                                    :next-operations "Próximas operaciones"
                                    :other-articles "Otros artículos"
                                    :accumulation-of-water "Acumulación de agua"
                                    :blisters "Ampollas"
                                    :surface-cracks "Grietas superficiales"
                                    :folds-or-wrinkles "Pliegues o arrugas"
                                    :shrinkage "Contracción"
                                    :welding-quality "Calidad de la soldadura"
                                    :previously-performed-repairs "Reparaciones previas"
                                    :surface-contamination "Contaminación superficial"
                                    :other-damages "Otros daños"}
                      :task-type {:sheet-and-patterns "Chapa y grecas"
                                  :fastening-arrangement "Disposición de fijaciones"
                                  :drains-and-downspouts "Desagües y bajantes"
                                  :water-entry "Entrada de agua"
                                  :other-pathologies "Otras patologías (precipitados, sales...)"
                                  :main-field-area "Zona principal del campo"
                                  :roof-edges-and-corners "Bordes y esquinas del tejado"
                                  :fixing-and-adhesive "Fijación y adhesivo"
                                  :drainage-system "Sistema de drenaje"
                                  :roof-penetrations "Penetraciones en el tejado"
                                  :plant-and-technical-protection "Protección de plantas y equipos técnicos"
                                  :alkorplan-solar-application "Aplicación solar Alkorplan"
                                  :other-items "Otros elementos"
                                  :accumulation-of-water "Acumulación de agua"
                                  :blisters "Ampollas"
                                  :superficial-cracks "Grietas superficiales"
                                  :folds-wrinkles "Pliegues / arrugas"
                                  :shrinkage "Contracción"
                                  :quality-of-the-welding "Calidad de la soldadura"
                                  :repairs-completed "Reparaciones realizadas"
                                  :surface-contamination "Contaminación superficial"
                                  :other-damages-or-pathologies "Otros daños o patologías"
                                  :hd-photographic-samples "Muestras fotográficas HD"
                                  :thermography "Termografía"
                                  :eld "ELD"
                                  :physical-samples-of-sheet "Muestras físicas de lámina"
                                  :sample-cover-package-tastings "Muestra del paquete de cubierta (catas)"}}}
   :form {:advanced-select {:load-more-data "Load more"
                            :no-data "No data"
                            :search "Search..."
                            :add "+Add"
                            :add-plus "Add +"
                            :select "Selecciona"
                            :include "Include"
                            :percentage "%"}
          :error-message {:revision "Hay un error o falta algo en el formulario."}}})
